// ── Renderer / Post-processing ────────────────────────────────────────
export const MULTISAMPLE_COUNT = 4;
export const AO_RADIUS = 5.0;
export const AO_INTENSITY = 3.0;
export const AO_SAMPLES = 8;
export const DENOISE_SAMPLES = 4;
export const DENOISE_RADIUS = 6;

// ── Camera frustum ratios ────────────────────────────────────────────
export const CAMERA_FRUSTUM_RATIO_WIDE = 0.75;
export const CAMERA_FRUSTUM_RATIO_MEDIUM = 0.5;
export const CAMERA_FRUSTUM_RATIO_NARROW = 0.25;

// ── Material defaults (optimized meshes) ─────────────────────────────
export const OPTIMIZED_METALNESS = 0.7;
export const OPTIMIZED_REFLECTIVITY = 0.6;
export const OPTIMIZED_ROUGHNESS = 0.5;
export const OPTIMIZED_CLEARCOAT_ROUGHNESS = 0.1;
export const OPTIMIZED_ENVMAP_INTENSITY = 0.2;
export const POLYGON_OFFSET_FACTOR = -2;

// ── Geometry processing ──────────────────────────────────────────────
export const BVH_MAX_LEAF_SIZE = 10;
export const WIRE_CUTOFF_ANGLE = 20;
export const GENERATED_SHAPE_CUTOFF_ANGLE = 45;

// ── Load indicator sphere ────────────────────────────────────────────
export const LOAD_SPHERE_RADIUS = 2;
export const LOAD_SPHERE_WIDTH_SEGMENTS = 32;
export const LOAD_SPHERE_HEIGHT_SEGMENTS = 16;

// ── Load indicator auto-fit (scales arrow & sphere to assembly bbox) ─
// Indicators are originally created at LOAD_INDICATOR_DEFAULT_LENGTH so
// proportions (sphere radius : arrow length) stay anchored to that value.
export const LOAD_INDICATOR_SCALE_FACTOR = 0.5;
export const LOAD_INDICATOR_DEFAULT_LENGTH = 40;
export const LOAD_INDICATOR_BBOX_EPSILON = 1e-6;

// ── FPS monitor ──────────────────────────────────────────────────────
export const FPS_THRESHOLD = 15;
export const FPS_CHECK_INTERVAL_MS = 1000;
export const FPS_STABILITY_DELAY_MS = 3000;

// ── Animation ────────────────────────────────────────────────────────
export const TEXTURE_ANIMATION_INTERVAL_MS = 1000 / 60;

// ── Scene defaults ──────────────────────────────────────────────────
export const DEFAULT_EMPTY_SIZE = 100;
